<template>
  <div
    class="mx-2 pb-1"
    :class="screenType !== 'desktop' && uploadStep === 1 && 'remaining-space-hidden d-flex flex-column'"
  >
    <StepForMobile
      :currentStep="1"
      :screenType="screenType"
      :title="this.$t('Route and Recipients')"
    />
    <div
      :class="[
        screenType !== 'desktop' &&
          uploadStep === 1 &&
          'single-step-wrapper-mobile remaining-space',
      ]"
    >
      <UploadingDetailsFields
        v-if="screenType === 'desktop' || uploadStep === 1"
        :session="session"
        :userActiveSourceRoutes="userActiveSourceRoutes"
        :errors="{}"
        :lightSessionRestart="lightSessionRestart"
        :screenType="screenType"
        :activeTab="activeTab"
        :isShowUploadingDetails="isShowUploadingDetails"
        :verifiedEmailsList="verifiedEmails"
        :pushToVerifiedEmailsList="pushToVerifiedEmailsList"
      />
      <!-- </v-tab-item> -->

      <!-- <v-tab-item value="casual" class="mt-2">
        <CasualSend :session="session" />
      </v-tab-item> -->
      <!-- </v-tabs> -->
    </div>
      <div
        v-if="screenType !== 'desktop' && uploadStep === 1"
        class="d-flex justify-end align-center mt-2 mx-2"
        style="height: 42px"
        @click="btnWrapperClicked"
      >
        <div v-if="isShowErrorMessage" class="mx-2">
          <span class="error-message">{{ getErrorMessage() }}</span>
        </div>
        <Button
          :disabled="getErrorMessage() !== ''"
          :text="$t('Continue')"
          :clickAction="continueButtonClicked"
        />
      </div>
  </div>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import UploadingDetailsFields from '@/components/WebsiteInterface/CommonComponents/UploadingDetailsFields/UploadingDetailsFields.vue'
import StepForMobile from '@/components/WebsiteInterface/CommonComponents/StepForMobile.vue'
import CasualSend from '@/components/WebsiteInterface/CommonComponents/CasualSend/CasualSend.vue'
import { mapGetters } from 'vuex'
import { getErrorOfDynmicFields } from '@/utils'

export default {
  name: 'Recipients',
  data() {
    return { isShowErrorMessage: false }
  },
  props: {
    session: Object,
    userActiveSourceRoutes: Array,
    lightSessionRestart: Function,
    screenType: String,
    activeTab: Object,
    isShowUploadingDetails: Boolean,
    continueButtonClicked: Function,
    userActiveSourceRoutes: Array,
    verifiedEmails: Array,
    pushToVerifiedEmailsList: Function,
  },
  computed: {
    ...mapGetters(['uploadStep', 'loggedUser']),

    // isShowTabs() {
    //   const isShowCasuals = this.loggedUser.isAllowCasuals
    //   const isShowRegistered = this.userActiveSourceRoutes.length > 0
    //   console.log('isShowCasuals: ' + isShowCasuals)
    //   console.log('isShowRegistered: ' + isShowRegistered)
    //   if (!isShowCasuals || !isShowRegistered) {
    //     const el = document.getElementsByClassName('v-slide-group')
    //     if (el && el.length && el[1]) el[1].style.display = 'none'
    //     return false
    //   } else {
    //     const el = document.getElementsByClassName('v-slide-group')
    //     if (el && el.length && el[1]) el[1].style.display = ''
    //   }

    //   return true
    // },
  },
  components: {
    Button,
    UploadingDetailsFields,
    StepForMobile,
    CasualSend,
  },
  methods: {
    btnWrapperClicked() {
      this.getErrorMessage()
      this.isShowErrorMessage = true
    },
    getErrorMessage() {
      // this.isShowErrorMessage = true
      if (this.activeTab.tab === 'regular') {
        if (!this.session.selectedRoute) {
          return this.$t('Route is required')
        }
        if (
          !this.session.selectedUsers ||
          this.session.selectedUsers.length === 0
        ) {
          return this.$t('At least one registered recipient is required')
        }
      } else if (this.activeTab.tab === 'casual') {
        if (
          !this.session.selectedCasualUsers ||
          this.session.selectedCasualUsers.length === 0
        ) {
          return this.$t('At least one guest recipient is required')
        }
      }
      const message = getErrorOfDynmicFields(this.session.interfaceDynamicFields, this.verifiedEmails)
      if (message) return message
      return ''
    },
  },
  watch: {
    session: {
      handler() {
        this.getErrorMessage()
        this.isShowErrorMessage = false
      },
      deep: true,
    },
  },
}
</script>

<style src="./Steps.css"></style>
<style scoped>
.overflow-small-screen-height {
  overflow: auto;
  max-height: calc(100vh - 200px);
}
.tabs-mobile {
  max-height: 100% !important;
}
.v-tabs >>> .v-window {
  /* min-height: 300px !important; */
  overflow: visible;
  /* overflow-y: auto !important */
}
.error-message {
  color: red;
  font-size: 14px;
  margin-right: auto;
  align-self: center;
}
</style>
